import startCase from "lodash/startCase";

const DASHBOARD = "dashboard";
const ANALYTICS = "analytics";
const EMBED = "embed";

export const SHORT_LINK_TABS = {
  DASHBOARD,
  ANALYTICS,
  EMBED
};

export const SHORT_LINK_ACTION_UID = {
  MERCHANT_CHECKOUT: "merchant_checkout"
};

const ACTIVE = "active";
const INACTIVE = "inactive";
const ARCHIVED = "archived";

export const SHORT_LINK_STATUS = {
  ACTIVE,
  INACTIVE,
  ARCHIVED
};

export const SHORT_LINK_STATUS_OPTIONS = [
  {
    uid: SHORT_LINK_STATUS.ACTIVE,
    label: startCase(SHORT_LINK_STATUS.ACTIVE),
    description: "Link is active and ready to be used."
  },
  {
    uid: SHORT_LINK_STATUS.INACTIVE,
    label: startCase(SHORT_LINK_STATUS.INACTIVE),
    description: "Link is inactive and attempts to used will be blocked."
  },
  {
    uid: SHORT_LINK_STATUS.ARCHIVED,
    label: startCase(SHORT_LINK_STATUS.ARCHIVED),
    description: "Link is archived and not available to be used."
  }
];

export const PRICE_CURRENCY_CONFLICT_VALIDATION_MESSAGE =
  "All prices must be in the same currency.";

export const FIXED_COUPON_CURRENCY_CONFLICT_VALIDATION_MESSAGE =
  "All fixed amount coupon selections must be in the same currency as selected prices.";

export const INTERVAL_CONFLICT_VALIDATION_MESSAGE =
  "All prices which are not one time charges, must have the same billing interval.";

export const PAYMENT_METHOD_TYPE_INTERVAL_CONFLICT_VALIDATION_MESSAGE = `Only the "Card" payment method is allowed for recurring prices.`;

export const ZERO_QUANTITY_VALIDATION_MESSAGE =
  "All prices must have a minimum quantity of 1.";

export const ZERO_TOTAL_VALIDATION_MESSAGE =
  "The total of your selections must be greater than zero.";

const CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS";
const CHECKOUT_CANCEL = "CHECKOUT_CANCEL";
const SHIPPING_DESTINATIONS = "SHIPPING_DESTINATIONS";

export const SHORT_LINK_SETTINGS = {
  CHECKOUT_SUCCESS,
  CHECKOUT_CANCEL,
  SHIPPING_DESTINATIONS
};

export const SHORT_LINK_FORM_TYPE = {
  PRICE: "price",
  PRICES: "prices",
  PRODUCTS: "products"
};
